import React, { Component } from 'react';

import {addCalculatorSymbols} from './calculator-helper'

import withStyles from '@material-ui/core/styles/withStyles';

const displayValue=(value)=>{
  if (!value) return "";
  return value.replace('/', '\u00F7').replace('*','\u00D7')
}

class CalculatorDisplay extends Component {
  render() {
    const { value, classes } = this.props;

    return (
    <div className={classes.container}>
      {addCalculatorSymbols(value)}
    </div>);
  }
}

const styles = ({ palette, spacing }) => ({
  container: {
    background: palette.background.paper,
    color: palette.text.primary,
    border: `1px solid ${palette.background.contrastText}`,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    // each button's own margin (spacing.unit on every side) creates its visual inset from the
    // row's edge - matching that same single inset on left+right here (not double it) is what
    // actually lines the display's edges up with the button grid below
    width: `calc(100% - ${spacing.unit * 2}px)`,
    height: '40px',
    padding: spacing.unit,
    fontFamily: 'Courier New, Courier, monospace',
    fontSize: '16px',
    margin: `${spacing.unit}px ${spacing.unit}px ${spacing.unit*.5}px  ${spacing.unit}px`,
    borderRadius: '5px',
    wordBreak: 'break-all',
    overflowY: 'auto',
    boxSizing: 'border-box'
  }
});

CalculatorDisplay = withStyles(styles)(CalculatorDisplay);

export { CalculatorDisplay };
